export default function getFormattedNum(num) {
    return num.toString().replace(/./g, function(c, i, a) {
        return i && c !== '.' && (a.length - i) % 3 === 0 ? ' ' + c : c
    })
}
